import Vimeo from "@u-wave/react-vimeo";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import ApiService from "../../service/api";
import { checkLogin } from "../../slices/AuthSlice";
import { showErrorToast } from "../../utils/ToastsModal";
import { Loader } from "../../widgets/Loader";

const CourseVideo = () => {
  const dispatch = useDispatch();
  let { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [videoList, setVideoList] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourseVideos();
  }, []);

  useEffect(() => {
    if (videoList.length > 0 && currentVideo === null) {
      setCurrentVideo({ index: 0, obj: videoList[0] });
    }
  }, [videoList]);

  const fetchCourseVideos = async () => {
    await ApiService.getCourseVideoList(id)
      .then((res) => {
        if (res.status === 200) {
          setVideoList(res.data);
        } else if (res.status === 202) {
          setError(res.data.message);
          setTimeout(() => {
            localStorage.removeItem("token");
            dispatch(checkLogin());
          }, 6000);
        }
        setLoading(false);
      })
      .catch((err) => {
        const res = JSON.parse(err?.request?.response);
        showErrorToast(res.message, 10000);
        setLoading(false);
      });
  };

  const addView = async () => {
    await ApiService.addViewVideo({
      video_id: currentVideo?.obj?.id,
    })
      .then((res) => {
        if (res.status === 201) {
          if (currentVideo.index < videoList.length) {
            const nextInd = currentVideo.index + 1;
            const updatedList = [...videoList];
            updatedList[currentVideo.index].isViewed = true;
            setVideoList(updatedList);
            setCurrentVideo({ index: nextInd, obj: videoList[nextInd] });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatedVimeoVideoId = (url) => {
    const splittedUrl = url?.split("/")[3];
    if (url.includes("https")) {
      if (!url.includes("https://player.vimeo.com/video")) {
        return `https://player.vimeo.com/video/${splittedUrl}`;
      } else {
        return url;
      }
    } else {
      return url;
    }
  };

  return (
    <MobileViewLayout>
      <div className="w-100">
        <div className="text-center w-100">
          <h4 className="mt-4" style={{ fontWeight: "600" }}>
            {currentVideo?.obj?.title}
          </h4>
          <h6 className="mt-1" style={{ color: "#6C6E79" }}>
            {currentVideo?.obj?.subtitle}
          </h6>
          <hr />
          <div className="">
            {error ? <h6 className="mt-5 text-main px-4">{error}</h6> : <></>}
            {loading ? (
              <Loader />
            ) : (
              <>
                {currentVideo !== null && currentVideo?.obj?.vimeo_video_id ? (
                  <Vimeo
                    video={updatedVimeoVideoId(
                      currentVideo?.obj?.vimeo_video_id
                    )}
                    className="w-100 m-0"
                    width={"100%"}
                    autoplay={true}
                    loop={false}
                    responsive={true}
                    onEnd={() => addView()}
                  />
                ) : (
                  <Loader />
                )}

                <hr />
                {videoList.map((e, index) => {
                  return (
                    <ListTile
                      e={e}
                      key={e.id}
                      index={index}
                      currentVideo={currentVideo}
                      setCurrentVideo={setCurrentVideo}
                      videoList={videoList}
                    />
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default CourseVideo;

const ListTile = ({ e, index, currentVideo, setCurrentVideo, videoList }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
    setCurrentVideo({ index: index, obj: videoList[index] });
  };

  return (
    <div
      className="text-start mt-2"
      style={{
        cursor: "pointer",
        marginBottom: index === videoList.length - 1 && "80px",
      }}
      onClick={handleClick}
    >
      <div className="d-flex align-items-start">
        <h3
          className={`me-3 rounded-circle p-3 text-center d-flex align-items-center justify-content-center fw-bold ${
            index === currentVideo?.index && "bg-main"
          }`}
          style={{
            height: "35px",
            width: "35px",
            backgroundColor:
              index !== currentVideo?.index ? "#DBDBDB" : "#419741",
            color: index !== currentVideo?.index ? "#000000" : "#FFFFFF",
          }}
        >
          {index + 1}
        </h3>
        <div>
          <h5
            className="m-0 color text-main fw-bold"
            style={{
              fontSize: "18px",
              color: index !== currentVideo?.index ? "#000000" : "#419741",
            }}
          >
            {e.title}
          </h5>
          <h6
            className="m-0 mt-1"
            style={{
              color: "#989898",
            }}
          >
            {e.subtitle}
          </h6>
        </div>
      </div>
      <hr />
    </div>
  );
};
